import { getToken } from './auth'
import utility from 'utility'
import JsEncrypt from 'jsencrypt'
import config from '@/config'
/**
 * 解析js日期
 * @param {string} jsonDate json格式化的日期
 */
export function parseJsonDate (jsonDate) {
  if (!jsonDate || jsonDate.length < 6) return ''
  // 格式类似：/Date(1410364800000-0000)/
  return new Date(parseInt(jsonDate.substr(6)))
}

/**
* 把一个js日期类型参数转换成 'yyyy-mm-dd' 格式字符串
* @param {string} format 日期格式, 如： yyyy-MM-dd hh:mm:ss
*/
export function formatDate (date, format = 'yyyy-MM-dd') {
  if (!date) return ''

  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  format = format.replace('MM', month.toString().replace(/^(\d)$/, '0$1'))

  if (format.indexOf('yyyy') > -1) {
    format = format.replace('yyyy', year.toString())
  } else if (format.indexOf('yy') > -1) {
    format = format.replace('yy', year.toString().substr(2, 2))
  }

  format = format.replace('dd', day.toString().replace(/^(\d)$/, '0$1'))

  if (format.indexOf('t') > -1) {
    if (hours > 11) {
      format = format.replace('t', 'pm')
    } else {
      format = format.replace('t', 'am')
    }
  }

  if (format.indexOf('HH') > -1) {
    format = format.replace('HH', hours.toString().replace(/^(\d)$/, '0$1'))
  }

  if (format.indexOf('hh') > -1) {
    if (hours > 12) {
      hours -= 12
    }

    if (hours === 0) {
      hours = 12
    }
    format = format.replace('hh', hours.toString().replace(/^(\d)$/, '0$1'))
  }

  if (format.indexOf('mm') > -1) {
    format = format.replace('mm', minutes.toString().replace(/^(\d)$/, '0$1'))
  }

  if (format.indexOf('ss') > -1) {
    format = format.replace('ss', seconds.toString().replace(/^(\d)$/, '0$1'))
  }

  return format
}

/**
 * 把布尔值转换成中文
 * @param {bool} value 布尔值
 */
export function toBoolText (value) {
  return value ? '是' : '否'
}

/**
 * 根据使用状态枚举返回对应的文本值
 * @param {string} value 使用状态
 */
export function toUseStatus (value) {
  return value === 'Valid' ? '启用' : '禁用'
}

/**
 * 数组分组
 * @param {array} xs 待分组的数组
 * @param {string} key 分组的key
 */
export function groupBy (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

/**
 * 得到上传控件需要的额外请求头,包括 Accept, Authorization
 */
export function getUploadHeaders () {
  return { Accept: 'application/json', Authorization: `Bearer ${getToken()}` }
}

export function getLastWeekData () { // 获得上周周一~周日的年月日
  var lastweek = [];
  var date = new Date();
  // 上周一的日期
  date.setDate(date.getDate() - date.getDay() - 6);
  lastweek.push((date.getMonth() + 1) + '.' + date.getDate())
  for (let i = 1; i < 7; i++) {
    date.setDate(date.getDate() + 1);
    lastweek.push((date.getMonth() + 1) + '.' + date.getDate())
  }
  return lastweek
}

export function encryptAccount (params) {
  const obj = {
    account: params.account,
    phone: params.account,
    password: utility.md5(params.password)
  }
  const jstr = JSON.stringify(obj)
  const encryptor = new JsEncrypt()
  encryptor.setPublicKey(config.publicKey)
  return encryptor.encrypt(jstr)
}

export function getQueryString (variable) {
  let url = decodeURI(window.location.href);
  var index = url.indexOf('?');// 获取地址栏路径并进行分割
  var query = url.substr(
    index + 1,
    url.length
  );
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] === variable) {
      console.log(pair[1]);
      return pair[1];
    }
  }
  return false;// 如果没有参数就返回false 值，就不会出现上边报错的情况了
}
